import { type GetScrapeDatesResponse } from '@bluebrick/discounts-service-module'
import { type DateTime } from 'luxon'
import { useApi } from '@/features/api/useAPI'
import { type DiscountsLastScrapeDates } from '@/features/dataHealth/types'
import { useTelemetry } from '@/features/telemetry/useTelemetry'
import { lastScrapeDatesSchemaLenient } from '@/schema'

export async function fetchDiscountsLastScrapeDates() {
	const { trackEvent, trackException } = useTelemetry()
	const { apiGet } = useApi()

	try {
		const { data } = await apiGet<GetScrapeDatesResponse>('/events/stores/lastScrapeDates')

		const result = lastScrapeDatesSchemaLenient.parse(data)?.reduce<DiscountsLastScrapeDates<DateTime>>((result, item) => {
			if (item.observationType === 'discounts') {
				result[item.storeName] = item.date
			}

			return result
		}, {})

		trackEvent('app', 'Fetched last discounts scrape dates.', {
			data: JSON.stringify(result)
		})

		return result
	} catch (e) {
		trackException(e as Error, 'Failed to fetch last discounts scrape dates.')
	}
}
